export default {
    name: 'GridDetails',
    props: {
        data: {
            type: Object,
            default: () => {
                return {
                    desktopColumnsWidth: [],
                    desktopHeader: [],
                    mobileColumnsWidth: [],
                    mobileHeader: [],
                    rows: []
                };
            }
        },
        striped: {
            type: Boolean,
            default: false
        },
        textAlignment: {
            type: String,
            default: 'left'
        }
    },
    computed: {
        rowsTotal() {
            return `repeat(${this.data.rows.length + 1}, auto)`;
        }
    }
};
